module.exports = __webpack_public_path__ + "img/hand3.af25c59e.svg";